
import { FETCH_INVEST_REQUEST, FETCH_INVEST_SUCCESS, FETCH_INVEST_FAILURE } from './actionsTypes';

export const fetchInvestRequest = (token,history) => ({
  type: FETCH_INVEST_REQUEST,
  payload: { token,history },
});

export const fetchInvestSuccess = (investData) => ({
  type: FETCH_INVEST_SUCCESS,
  payload: { investData },
});

export const fetchInvestFailure = (error) => ({
  type: FETCH_INVEST_FAILURE,
  payload: { error },
});

